/* ============================================================
 * Mobile slider – shared behavior
 * Builds dot pagination for every [data-m-slider] on mobile and
 * keeps the active dot in sync with the swipe position. Native
 * CSS scroll-snap handles the swiping; this only adds the dots.
 * ============================================================ */
(function () {
  if (window.__mSliderInit) return;
  window.__mSliderInit = true;

  var MQ = window.matchMedia('(max-width: 749px)');

  function slidesOf(slider) {
    return Array.prototype.filter.call(slider.children, function (el) {
      return el.nodeType === 1 && !el.classList.contains('m-slider-dots');
    });
  }

  function init(slider) {
    if (slider.__mInit) return;
    var slides = slidesOf(slider);
    if (slides.length < 2) return;
    slider.__mInit = true;

    var dots = document.createElement('ul');
    dots.className = 'm-slider-dots';
    dots.setAttribute('aria-hidden', 'true');

    slides.forEach(function (slide, i) {
      var li = document.createElement('li');
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'm-slider-dots__dot';
      dot.addEventListener('click', function () {
        var offset = slide.offsetLeft - (slider.clientWidth - slide.clientWidth) / 2;
        slider.scrollTo({ left: offset, behavior: 'smooth' });
      });
      li.appendChild(dot);
      dots.appendChild(li);
    });

    slider.insertAdjacentElement('afterend', dots);

    function update() {
      var center = slider.scrollLeft + slider.clientWidth / 2;
      var active = 0;
      var best = Infinity;
      slides.forEach(function (slide, i) {
        var slideCenter = slide.offsetLeft + slide.clientWidth / 2;
        var distance = Math.abs(slideCenter - center);
        if (distance < best) {
          best = distance;
          active = i;
        }
      });
      Array.prototype.forEach.call(dots.children, function (li, i) {
        li.firstChild.classList.toggle('is-active', i === active);
      });
    }

    slider.addEventListener('scroll', function () {
      window.requestAnimationFrame(update);
    }, { passive: true });
    update();
  }

  function run() {
    if (!MQ.matches) return;
    document.querySelectorAll('[data-m-slider]').forEach(init);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);

  if (MQ.addEventListener) MQ.addEventListener('change', run);
  else if (MQ.addListener) MQ.addListener(run);
})();
